/* eslint-disable import/prefer-default-export */
import { history } from '../../history';
import config from '../../config';
import { LOAD_EXTENSION, LOAD_EXTENSION_ERROR, LOAD_EXTENSION_SUCCESS } from './constants';
import { BAD_ROUTE } from '../constants';
import { checkStatus, handleRequestError } from '../utils/helpers';

const requestExtensionAction = idOrRoute => ({
  type: LOAD_EXTENSION,
  payload: idOrRoute,
});

const receiveExtensionAction = extension => ({
  type: LOAD_EXTENSION_SUCCESS,
  payload: extension,
});

const errorExtensionAction = (error, idOrRoute) => ({
  type: LOAD_EXTENSION_ERROR,
  payload: { error, idOrRoute },
});

const errorRedirectAction = () => ({
  type: BAD_ROUTE,
  payload: '/404',
});

const redirectIfOldBrandRoute = (idOrRoute, isBrandPageLookup) => (extension) => {
  if (extension && isBrandPageLookup && extension.route !== idOrRoute) {
    history.replace(`/brands/${extension.route}`);
    return false;
  }
  return extension;
};

export const fetchExtension = (idOrRoute, isBrandPageLookup = false) => (dispatch) => {
  const isUuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/.test(idOrRoute);
  if (!idOrRoute || isUuid) {
    return false;
  }

  dispatch(requestExtensionAction(idOrRoute));

  const url = `${config.url}/extension/${idOrRoute}?include=brand`;
  return fetch(url, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  })
  .then(checkStatus)
  .then(redirectIfOldBrandRoute(idOrRoute, isBrandPageLookup))
  .then((extension) => {
    if (extension === false) return;
    dispatch(receiveExtensionAction(extension));
  })
  .catch((error) => {
    errorExtensionAction(error, idOrRoute);
    if (error.code === 'ServiceUnavailable') {
      handleRequestError(dispatch)(error);
    } else if (isBrandPageLookup) {
      dispatch(errorRedirectAction());
    }
  });
};



// WEBPACK FOOTER //
// ./src/app/extensions/actions.js